import * as PropTypes from 'prop-types'
import * as React from 'react'

import { downColor, upColor } from '../../../styles'
import { ERROR } from './Toaster.constants'
// prettier-ignore
import { ToasterClose, ToasterContent, ToasterCountdown, ToasterGrid, ToasterIcon, ToasterMessage, ToasterStyled, ToasterTitle } from './Toaster.style'

type ToasterViewProps = {
  showing: boolean
  status?: string
  title: string
  message: string
  closeCallback: () => void
}

export const ToasterView = ({ showing, status, title, message, closeCallback }: ToasterViewProps) => {
  const backgroundColor = status === 'success' ? upColor : downColor

  return (
    <ToasterStyled className={showing ? 'showing' : 'hidden'}>
      <ToasterGrid>
        <ToasterIcon status={status}>
          <svg>
            <use xlinkHref={`/images/sprites.svg#${status}`} />
          </svg>
        </ToasterIcon>
        <ToasterContent>
          <ToasterTitle>{title}</ToasterTitle>
          <ToasterMessage>{message}</ToasterMessage>
        </ToasterContent>
        <ToasterClose onClick={() => closeCallback()}>
          <svg>
            <use xlinkHref="/images/sprites.svg#close" />
          </svg>
        </ToasterClose>
      </ToasterGrid>
      <ToasterCountdown className={showing ? 'showing' : 'hidden'} style={{ backgroundColor }} />
    </ToasterStyled>
  )
}

ToasterView.propTypes = {
  showing: PropTypes.bool.isRequired,
  status: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  closeCallback: PropTypes.func.isRequired,
}

ToasterView.defaultProps = {
  status: ERROR,
  title: 'Error',
  message: 'Undefined error',
}
